import React from 'react';
import { useDispatch } from 'react-redux';
import elementsActions from 'actions/editor/elements';
import GeneratedFreeResponse from './GeneratedFreeResponse';
import ActionButtons from './ActionButtons';

const FreeResponseBody = ({
  dismissCallback,
  position,
  selectedQuestionType,
  generatedOptions,
  setGeneratedOptions,
  generate,
  questionText,
  back,
  sendLLMFeedback,
}) => {
  const dispatch = useDispatch();

  const addQuestionToSection = (idx, subject, required) => {
    setGeneratedOptions(prevOptions =>
      prevOptions.map((option, i) => {
        return idx !== i ? option : { ...option, added: true };
      }),
    );

    const numQuestionsAdded = generatedOptions.filter(op => op.added).length;

    dispatch(
      elementsActions.createAIGeneratedElement(
        selectedQuestionType,
        position + numQuestionsAdded,
        {
          subject,
          required,
        },
      ),
    );
  };

  return (
    <>
      {generatedOptions.map((option, index) => {
        const { question, added } = option;
        return (
          <GeneratedFreeResponse
            key={question}
            index={index}
            question={question}
            added={added}
            addQuestionToSection={addQuestionToSection}
            tryAgain={generate}
            sendLLMFeedback={sendLLMFeedback}
          />
        );
      })}
      <ActionButtons
        back={back}
        tryAgain={() => generate(questionText)}
        primaryAction={dismissCallback}
        primaryActionText={t('lessons.editor.element_assistant.actions.done')}
      />
    </>
  );
};

export default FreeResponseBody;
